import { Box, styled } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
  // padding: theme.spacing(3),
  marginTop: theme.spacing(8),
  marginBottom: theme.spacing(8),
}));
